<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Resit">

            

            
            <w-flex justify-space-between class="mb4">
              <div class="xs3">
                    <z-lookup label="Jenis Pembayaran" name="status" :url='service_ibayaq+"sumber"' :sort="false" :cache="false" v-model="cari.lkp_sumber_id" /> 
                </div>

               <div class="xs3"> 
                    <z-lookup label="Cara Bayaran" name="status" :url='service_ibayaq+"cara_terima"' :sort="false" :cache="false" v-model="cari.lkp_cara_terima_id" /> 
                </div>
               <div class="xs3"> 
                    <w-input v-model="cari.no_resit" required label="No. Resit " /> 
                </div>
                 <div class="xs3">
                  <w-input v-model="cari.no_rujukan" required label="No. Rujukan " /> 
                 </div>
            </w-flex>
            <w-flex justify-space-between class="mb4">
              
               <div class="xs3"> 
                    <w-input v-model="cari.tarikh_bayar_dari" type="date" required label="Tarikh Bayar Dari" /> 
                </div>
                 <div class="xs3"> 
                    <w-input v-model="cari.tarikh_bayar_hingga" type="date" required label="Tarikh Bayar Hingga" /> 
                </div>
                 <div class="xs3">
                  <w-input v-model="cari.keterangan" required label="Nama" /> 
                 </div>
                 <div class="xs3">
                    <z-lookup
                      label="Status Penyesuaian"
                      :options="penyesuaian_status"
                      v-model="cari.penyesuaian_status"
                      :sort="false"
                      :cache="false"
                    />
                 </div>
            </w-flex>
             <w-flex justify-space-between class="mb4">
              
               <div class="xs3"> 
                  <w-input v-model="cari.payment_id" required label="No. Bank" /> 
                </div>
                <div class="xs3">
                    <!-- <z-lookup label="Status Resit" name="status_resit" :url='service_ibayaq+"lookup/status_resit"' :sort="false" :cache="false" v-model="cari.lkp_resit_status_id" />  -->
                    <z-lookup
                      label="Status Resit"
                      :options="resit_status"
                      v-model="cari.resit_status"
                      :sort="false"
                      :cache="false"
                    />
                 </div>
                 <div class="xs3">
                 </div>
                 <div class="xs3">
                 </div>

            </w-flex>

                    

            <div class="mt2 text-right">
                 <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button>
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="carian()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>

            <z-table ref="tbluser" title="Senarai : Resit " :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                    <a :href="item.cetak"><w-icon>fal fa-print</w-icon></a>
                    &nbsp;&nbsp;&nbsp;
                    <inertia-link :href='$route("kutipan.resit.show_ibayaq",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                  </w-flex>
                    
                </template>
            </z-table>
            <w-flex class="mt3" wrap align-center justify-end>
               <!--  <w-button bg-color="success" class="mr3" @click="cetak">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                </w-button> -->
                <!-- &nbsp;&nbsp; -->
                <!-- <w-button bg-color="success" class="mr3" @click="SenaraiCetakan()">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button> -->
               
                 
            </w-flex>

        </z-page>
        <!-- <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Cetak Senarai
            </template>

             <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <z-input 
                          label="Tarikh Dari" 
                          name="tarikh_dari" 
                          v-model="cari.tarikh_dari" 
                           type="date"/>
                </div>
                 <div class="xs4"> 
                    <z-input 
                          label="Tarikh hingga *" 
                          name="tarikh_hingga" 
                          v-model="cari.tarikh_hingga"
                           type="date"/>
                </div>
                 <div class="xs4"> 
                 </div>
            </w-flex>
            

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                </w-button>
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog> -->
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    jabatan : String
  },
  data() {
    return {
        resourceurl: this.service_ibayaq +'resit/'+this.jabatan,
        loading : true,
        reload: true,
        resit_id : null,
        cari : {},
        penyesuaian_status: [
                {
                    value: 3,
                    label: "BELUM DIPROSES",
                },
                {
                    value: 4,
                    label: "BATAL"
                },
                {
                    value: 1,
                    label: "SEPADAN",
                },
                {
                    value: 2,
                    label: "TIDAK SEPADAN"
                },
            ],
        resit_status: [
                {
                    value: 1,
                    label: "KUATKUASA",
                },
               
                {
                    value: 2,
                    label: "BATAL"
                }
            ],
        dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Resit IBayaq', route: '/kutipan/resit/ibayaq' },
            { label: 'Senarai', route: '/kutipan/resit/ibayaq' }
          ],
          cari : {lkp_sumber_id:'', no_resit:'', no_rujukan:'', tarikh_bayar: '', tarikh_dari: '', tarikh_hingga : '', lkp_cara_terima_id :'', keterangan : '', penyesuaian_status: '', payment_id: '', resit_status: ''},

          pilih : false
        }
         
  },
  methods: {

    carian() {
             this.$inertia.visit(window.route('kutipan.resit.ibayaq', this.jabatan)+'?jabatan='+this.jabatan+'&no_resit='+this.cari.no_resit+'&lkp_sumber_id='+this.cari.lkp_sumber_id+'&tarikh_bayar_dari='+this.cari.tarikh_bayar_dari+'&tarikh_bayar_hingga='+this.cari.tarikh_bayar_hingga+'&lkp_cara_terima_id='+this.cari.lkp_cara_terima_id+'&no_rujukan='+this.cari.no_rujukan+'&keterangan='+this.cari.keterangan+'&penyesuaian_status='+this.cari.penyesuaian_status+'&payment_id='+this.cari.payment_id+'&resit_status='+this.cari.resit_status , {preserveScroll:true})
            
        },
        reset(){
              this.cari = {lkp_sumber_id:'', no_resit:'', no_rujukan:'', tarikh_bayar: '', tarikh_dari: '', tarikh_hingga : '', lkp_cara_terima_id :'', keterangan : '', penyesuaian_status: '', payment_id: '', resit_status: ''}
              this.carian()
        },

        cetakSenarai() {
                window.location.href = this.service_ibayaq+'resit/cetaksenarai/'+'cetak'+'?jabatan='+this.jabatan+'&no_resit='+this.cari.no_resit+'&lkp_sumber_id='+this.cari.lkp_sumber_id+'&tarikh_bayar_dari='+this.cari.tarikh_bayar_dari+'&tarikh_bayar_hingga='+this.cari.tarikh_bayar_hingga+'&lkp_cara_terima_id='+this.cari.lkp_cara_terima_id+'&no_rujukan='+this.cari.no_rujukan+'&keterangan='+this.cari.keterangan+'&penyesuaian_status='+this.cari.penyesuaian_status+'&payment_id='+this.cari.payment_id+'&resit_status='+this.cari.resit_status , {preserveScroll:true};
        },

        cekPilih(){
        
        for (var i in this.table.items) {
            this.table.items[i].pilih = this.pilih
        }
      },

      search() {
      var url = window.route('kutipan.resit.index')+'?resit_id='+this.resit_id;
      this.$inertia.visit(url, { preserveScroll : true})
    },
    // load() {
    //     // this.loading = true
    //     this.$zcomm.get(this.service_ibayaq +'resit/'+this.jabatan+window.location.search)
    //     .then(res => {
    //       })
    //     .finally(() => {

    //         this.loading = false
    //         });
    // },


      

  },
  watch: {
    
  },
  mounted() {
    // this.load();
    // override default setting
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari && this.cari.keterangan && this.cari.keterangan == 'undefined'){
      this.cari.keterangan = ''
    }
    if(this.cari && this.cari.no_resit && this.cari.no_resit == 'undefined'){
      this.cari.no_resit = ''
    }
    if(this.cari && this.cari.no_rujukan && this.cari.no_rujukan == 'undefined'){
      this.cari.no_rujukan = ''
    }
    if(this.cari && this.cari.penyesuaian_status && this.cari.penyesuaian_status == 'undefined'){
      this.cari.penyesuaian_status = ''
    }
    if(this.cari && this.cari.resit_status && this.cari.resit_status == 'undefined'){
      this.cari.resit_status = ''
    }
    // this.carian();
    this.dialog.width = 900
    
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>